// import * as apis from '@apis'
const vote = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'nis-vote'
    }
  },
  getters: {},
  mutations: {
  },
  actions: {}
}

export default vote
